export const signUpClient = {
    basicInfo: 'Basic information',
    contractInfo: 'Application responsibility information',
    companyName: 'Company',
    country: 'Country',
    postalCode: 'Postal code',
    companyAddress: 'Address',
    representativeName: 'Representative Name',
    phoneNumber: 'Phone number',
    phoneNumberTip: '(Input example：+819012345678)',
    industries: 'Organization name',
    contractName1: "Applicant responsibility's name",
    contractNumber1: 'Phone number',
    contractEmail1: 'Email address',
    contractName2: 'Contract representative name2',
    contractNumber2: 'Contract representative number2',
    contractEmail2: 'Contract representative email2',
    mailDomain1: 'mailDomain1',
    mailDomain2: 'mailDomain2',
    mailDomain3: 'mailDomain3',
    mailDomain1Tip: `(For the email address of xxx@domain.co.jp, please enter "domain.co.jp".)`,
    moreMailDomainTip: '(If you have multiple email domains, please register.)',
    contractPlan: 'Contract plan',
    contractDate: 'Contract date',
    clientTheme: 'Client Theme',
    agree: 'Agree to contract plan disclaimer',
    trialLabel: 'Turn it on for a trial',
    trial: 'Trial',
    signUp: 'Registration',
    contractPlanList: {
        basic: 'Basic',
        advanced: 'Advanced',
        managed: 'Managed'
    },
    warningMsg: {
        isRequired: 'Please enter.',
        selectIsRequired: 'Please select.',
        mailDomainError: 'Please enter and specify.',
        typoError: 'Please enter only the code and alphanumeric characters.',
        incorrectEmailFormat: 'The email format is incorrect.',
        incorrectPhoneNumberFormat: 'The phone number format is incorrect.',
        duplicatedEmail: "The user has already existed. Now can't register.",
        registrationSuccess: 'Processing ended normally.',
        registrationError: 'Processing failed.'
    }
}
